import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'hbo-reactive-modal',
  templateUrl: './reactive-modal.component.html',
  styleUrls: ['./reactive-modal.component.scss']
})
export class ReactiveModalComponent {

  @Input() id?: string | number;
  @Output() confirm = new EventEmitter();


  @Input() head?: string;
  @Input() head5?: string;
  @Input() message?: string;

  @Input() hideConfirm?:boolean;

}
